import { Component } from '@theme/component';
import { morph } from '@theme/morph';
import { StandardEvents } from '@shopify/events';

class AdminV2StockAction extends Component {
  #section;
  #selection = 0;

  connectedCallback() {
    super.connectedCallback();
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    this.#selection++;
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    super.disconnectedCallback();
  }

  /** @param {import('@shopify/events').ProductSelectEvent} event */
  #handleProductSelect = async (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    const selection = ++this.#selection;

    try {
      const { detail } = await event.promise;
      if (!detail?.html || !this.isConnected || selection !== this.#selection) return;
      if (!detail.newProduct && detail.productId && String(detail.productId) !== this.dataset.productId) return;

      const replacement = Array.from(detail.html.querySelectorAll('admin-v2-stock-action'))
        .find((element) => element.dataset.blockId === this.dataset.blockId);
      if (!replacement) return;

      this.dataset.productId = replacement.dataset.productId;
      morph(this, replacement, { childrenOnly: true });
    } catch (error) {
      if (error?.name !== 'AbortError') console.warn('[admin-v2-stock-action] Update failed:', error);
    }
  };
}

if (!customElements.get('admin-v2-stock-action')) {
  customElements.define('admin-v2-stock-action', AdminV2StockAction);
}
